import { applicationSteps, organisation } from '../../data/mockData';
import Icon from '../ui/Icon';
import SectionHeading from '../ui/SectionHeading';
import applyImage from '../../assets/apply-image.jpg';

export default function HowToApply() {
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={applyImage}
          alt="How to apply background"
          className="h-full w-full object-cover"
          loading="lazy"
        />
        {/* Overlay for content contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 to-white/50" />
      </div>

      <div className="section-shell relative z-10">
        <SectionHeading
          eyebrow="Standard application process"
          title="How to apply"
          description="Four steps from choosing a programme to your first day of class."
        />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {applicationSteps.map((step, index) => (
            <li key={step.id} className="relative">
              {index < applicationSteps.length - 1 && (
                <span
                  aria-hidden="true"
                  className="absolute left-full top-9 hidden h-px w-5 bg-canvas-300 lg:block"
                />
              )}
              <div className="card-surface h-full p-6">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-gradient text-white">
                    <Icon name={step.icon} className="h-5 w-5" />
                  </span>
                  <span className="text-xs font-bold uppercase tracking-widest text-brand-600">
                    Step {step.step}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-bold text-brand-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-900/60">
                  {step.description}
                </p>
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-8 text-center text-sm text-brand-900/60">
          Questions about your application? Email{' '}
          <a
            href={`mailto:${organisation.trainingEmail}`}
            className="font-semibold text-brand-700 underline underline-offset-4 hover:text-brand-800"
          >
            {organisation.trainingEmail}
          </a>{' '}
          or call{' '}
          <a
            href={`tel:${organisation.phoneDial}`}
            className="font-semibold text-brand-700 underline underline-offset-4 hover:text-brand-800"
          >
            {organisation.phoneDisplay}
          </a>
          .
        </p>
      </div>
    </section>
  );
}
